import homeApi from "@/api/homeApi";
import { atom } from "jotai";
import { scrollToTop } from "@/utils/scrollToTop";
import { clickTabAtom, keyDidAtom, positionAtom, refreshLocAtom, toggleCityAtom } from "./app";
import timeZoneApi from "@/api/timeZoneApi";
import { pathnameAtom, commonStateAtom, keyId, keyAid, keyBid, keyCid, keyDid, _latitude, _longitude } from "./common";
import { refreshCurrGeo } from "./utils/refreshCurrGeo";
import { useApiMap } from "./hooks/useApiMap";
import {
  applyCompactHeaderToAtomAndStorage,
  assignKeyDidToParams,
  buildCompactHeaderFromInfo,
  clearKeyAidBidCidDidWhenRefreshingLoc,
  persistInfoLocalStorageHomeStyle,
  persistKeyAidFromHomeOrLocationResponseInfoKey,
} from "./utils/weatherQueryShared";
const getKeyId = (
  keyAid: any,
  keyBid: any,
  keyCid: any,
  keyDid: any,
  cacheKeyAid: any,
  cacheKeyId: any,
  keyId: any,
  info: any,
) => {
  if (keyAid || keyBid || keyCid || keyDid) {
    return cacheKeyAid || cacheKeyId || keyId || info?.key;
  }
  return cacheKeyId || cacheKeyAid || keyId || info?.key;
};

//  可写派生原子：接收外部参数并执行请求
const homeAtom = atom(
  get => get(commonStateAtom),
  async (get, set, params: string = "") => {
    scrollToTop();
    set(pathnameAtom, params);
    if (!keyId && (keyAid || keyBid || keyCid || keyDid)) {
      LocalStorage.removeItem("SELECT_CITY");
      LocalStorage.removeItem("KEY_ID");
      LocalStorage.removeItem("TIME_ZONE");
    }
    if (keyId && !(keyAid || keyBid || keyCid || keyDid)) {
      LocalStorage.removeItem("KEY_AID");
    }
    // Handle case when keyId exists
    if (!isEmptyType(keyId)) {
      set(keyIdHandlerAtom, String(keyId));
      return;
    }
    // Handle local selected city scenario
    const locSelCity = LocalStorage.getItem("SELECT_CITY");
    const clickTab = get(clickTabAtom);
    if (!isEmptyType(locSelCity) || clickTab) {
      set(localCityHandler, locSelCity?.Key);
      return;
    }
    // Fallback to geolocation
    refreshCurrGeo();
  },
);
const localCityHandler = atom(null, async (get: any, set: any, newKeyId: string) => {
  set(commonStateAtom, (prev: any) => ({
    ...prev,
    params: {
      ...prev.params,
      keyId: newKeyId,
    },
  }));
  const params = get(commonStateAtom)?.params;
  useApiMap(params, { key: "lifestyle" });
});

const keyIdHandlerAtom = atom(null, async (get, set, newKeyId: string) => {
  const refreshloc = get(refreshLocAtom);
  const toggleCity = get(toggleCityAtom);
  const clickTab = get(clickTabAtom);
  const locSelCity = LocalStorage.getItem("SELECT_CITY");
  newKeyId = clickTab && (refreshloc || toggleCity) ? locSelCity?.Key : newKeyId;
  set(commonStateAtom, (prev: any) => ({
    ...prev,
    params: {
      ...prev.params,
      keyId: newKeyId,
    },
  }));
  if (clickTab) {
    set(callback1Atom);
    return;
  }
  set(refreshTZAtom);
});
// Home 查询
const queryHomeAtom = atom(null, async (get, set, newParams: any) => {
  const refreshloc = get(refreshLocAtom);
  const toggleCity = get(toggleCityAtom);
  clearKeyAidBidCidDidWhenRefreshingLoc(newParams, !!refreshloc || !!toggleCity);
  assignKeyDidToParams(newParams, get(keyDidAtom));
  const locKeyAid = LocalStorage.getItem("KEY_AID");
  const locKeyId = LocalStorage.getItem("KEY_ID");
  const locInfo = LocalStorage.getItem("INFO");
  const { latitude, longitude } = get(positionAtom);
  const isPositionZero = () =>
    !isEmptyType(latitude) && latitude * 1 === 0 && !isEmptyType(longitude) && longitude * 1 === 0;
  const hasSearchParams = !isEmptyType(_latitude) && !isEmptyType(_longitude) && !isEmptyType(keyId);
  const needFallback =
    (isEmptyType(newParams?.keyId) &&
      isEmptyType(_latitude) &&
      isEmptyType(_longitude) &&
      ((isEmptyType(latitude) && isEmptyType(longitude)) || isPositionZero())) ||
    (isPositionZero() && hasSearchParams);

  if (!newParams?.keyId && (needFallback || !isEmptyType(locInfo) || keyId || keyAid || keyBid || keyCid || keyDid)) {
    newParams.keyId = getKeyId(keyAid, keyBid, keyCid, keyDid, locKeyAid, locKeyId, keyId, locInfo);
  }
  set(commonStateAtom, (prev: any) => ({
    ...prev,
    params: {
      ...newParams,
      test: isDevEnv ? 1 : undefined,
    },
    loading: true,
    error: null,
  }));
  try {
    const resData: any = await homeApi.queryHome(newParams);
    LocalStorage.setItem("AWS_CON", resData.data?.awsCon);
    const infoData = resData?.data?.info;
    persistKeyAidFromHomeOrLocationResponseInfoKey(infoData?.key);
    persistInfoLocalStorageHomeStyle(infoData);
    if (keyId) {
      LocalStorage.setItem("SELECT_CITY", infoData);
    }
    const resHeader = buildCompactHeaderFromInfo(infoData);
    applyCompactHeaderToAtomAndStorage(set, resHeader);
    LocalStorage.setItem("API_ALL", resData);
    set(commonStateAtom, (prev: any) => ({
      ...prev,
      data: resData.data,
    }));
    return resData;
  } catch (err: any) {
    set(commonStateAtom, (prev: any) => ({
      ...prev,
      loading: false,
      error: err.message,
    }));
    throw err;
  }
});

const callback1Atom = atom(null, async (get: any) => {
  const params = get(commonStateAtom).params;
  useApiMap(params);
});
const refreshTZAtom = atom(null, async (get: any, set: any, keyId = "") => {
  const _keyId = keyId || get(commonStateAtom).params.keyId;
  const params = {
    keyId: _keyId,
  };

  const resData: any = await timeZoneApi.query(params);
  LocalStorage.setItem("KEY_ID", _keyId);
  LocalStorage.setItem("TIME_ZONE", resData.data.timeZone);
  set(callback1Atom);
  return resData.data.timeZone;
});
export { homeAtom, pathnameAtom, queryHomeAtom, keyIdHandlerAtom };
